// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__Q2fVD","inputWrap":"Table_inputWrap__1jMRH","col":"Table_col__1lyv8","bmiTooltip":"Table_bmiTooltip__X6oPe"};